export default __webpack_public_path__ + "static/media/Gilroy-Light.5ac18846.otf";